import {InternalAffairsComplaintResponse} from "../../../data/internal-affairs/InternalAffairsComplaintResponse";
import {EditorContent} from "../../editor/EditorContent";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Alert,
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    Stack,
    Typography
} from "@mui/material";
import React, {useState} from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import WarningIcon from '@mui/icons-material/Warning';
import {makeApiCall} from "../../../hooks/CancellableApiCall";

export interface IABannerProps {
    complaint: InternalAffairsComplaintResponse,
    onSuccess: (type: iaCommandDecision) => void,
    onFail: () => void
}

export type iaCommandDecision = "CC_MEETING" | "CC_QUICK_VOTE" | "CLOSE"

export const IACMDReview = (props: IABannerProps) => {
    const [expanded, setExpanded] = useState(false)

    function sendIACommandDecision(decision: iaCommandDecision) {
        props.onSuccess(decision)
        makeApiCall({
            url: `/api/internal-affairs/ia-command-decision/${props.complaint.displayId}`,
            method: "POST",
            body: {
                decision: decision
            },
            onLoadedCallback: () => {},
            onError: () => {props.onFail()}
        })
    }

    return <>
        <Alert severity="warning">This is the last stage where a investigator can be assigned / un-assigned, or have the complaint classification changed</Alert>
        <Accordion expanded={expanded}>
            <AccordionSummary>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Stack spacing={2} direction={"row"} sx={{display: "flex", alignItems: "center"}}>
                            <Typography variant={"subtitle1"}>
                                <Typography sx={{pt:2}} variant="h6" gutterBottom>Internal Affairs Command Review</Typography>
                            </Typography>
                            <IconButton
                                sx={{ height: "30px", width: "30px" }}
                                color="primary"
                                onClick={() => setExpanded(!expanded)}
                            >
                                {expanded ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                            </IconButton>
                        </Stack>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <EditorContent content={props.complaint.finalReport.content} />
                <Divider />
                <Box>
                    <Stack direction={"row"} sx={{marginTop: "10px"}} spacing={3}>
                        <Button size={"medium"} variant="contained" sx={{
                            display: {xs: "none", sm: "flex"}}} onClick={() => {sendIACommandDecision("CC_MEETING")}}>
                            Send to Complaint Committee Meeting
                        </Button>
                        <Button size={"medium"} variant="contained" sx={{
                            display: {xs: "none", sm: "flex"}}} onClick={() => {sendIACommandDecision("CC_QUICK_VOTE")}}>
                            Send to Expedited Review
                        </Button>
                        <Button color={"warning"} size={"medium"} variant="contained" sx={{
                            display: {xs: "none", sm: "flex"},
                            float: "right"
                        }} onClick={() => {sendIACommandDecision("CLOSE")}}>
                            <WarningIcon sx={{paddingRight: "8px", height: "30px", width: "30px"}}/>
                            Close Complaint due to Lack of Evidence
                        </Button>
                    </Stack>
                </Box>
            </AccordionDetails>
        </Accordion></>
}